/* PC Praha – poloha reklamních bannerů v mřížce kolekce ASIC (23. 10. 2026), blocks/pcp-sety-banner.liquid a blocks/pcp-hosting-banner.liquid (27. 10. 2026).
   Banner je <li class="pcp-sety-li"> (obal bloku) přes celý řádek mřížky; není to karta (.product-grid__item), takže ho filtry (assets/pcp-asic-filtry.js)
   nepočítají ani neřadí. Filtry a řazení karty přeskládávají a skrývají (třída pcp-af-hide), proto se banner po každé takové změně
   vloží za konec řádku nejblíž 8. VIDITELNÉ kartě (telefon do 749 px: 4.); když filtr žádnou kartu nenechá, banner se skryje.
   Další banner (hosting, data-pcp-rows="2" na obalu nebo na bloku) jde o tolik celých řádků níž. Když na to není dost karet a nad ním už je jiný banner,
   skryje se (dva bannery by byly těsně u sebe); bez jiného banneru jde na konec mřížky.
   Bez JS zůstává tam, kam ho vypsal Liquid (sety za 8., hosting za 16. produktem). */
(function () {
  if (window.PCP_SETY) return;
  window.PCP_SETY = true;
  var mq = window.matchMedia('(max-width: 749px)');

  function rowsOf(b) {
    var c = b.hasAttribute('data-pcp-rows') ? b : b.querySelector('[data-pcp-rows]');
    return (c && parseInt(c.getAttribute('data-pcp-rows'), 10)) || 0;
  }

  function place(grid, list) {
    var vis = [].filter.call(grid.children, function (el) {
      return el.classList.contains('product-grid__item') && !el.classList.contains('pcp-af-hide');
    });
    var cols = (getComputedStyle(grid).gridTemplateColumns || '').split(/\s+/).filter(Boolean).length || 1;
    var want = mq.matches ? 4 : 8;
    var base = Math.max(cols, Math.round(want / cols) * cols);
    var shown = 0, used = [];
    list.forEach(function (b) {
      var rows = rowsOf(b);
      if (!vis.length) { if (!b.hidden) b.hidden = true; return; }
      var n = Math.min(base + rows * cols, vis.length);
      /* dva bannery nikdy za stejnou kartu (jinak by se donekonečna přeskakovaly) ani těsně pod sebou */
      if (shown && (n > vis.length - 1 || used.indexOf(n) > -1 || used.some(function (u) { return Math.abs(u - n) < cols; }))) { if (!b.hidden) b.hidden = true; return; }
      if (b.hidden) b.hidden = false;
      shown++;
      used.push(n);
      var at = vis[n - 1];
      if (at.nextElementSibling !== b) at.after(b);
    });
  }

  function init() {
    var all = [].slice.call(document.querySelectorAll('.product-grid > li.pcp-sety-li'));
    if (!all.length || !all[0].parentElement) return;
    var grid = all[0].parentElement, queued = false;
    var list = all.filter(function (b) { return b.parentElement === grid; }).sort(function (a, b) {
      return rowsOf(a) - rowsOf(b);
    });
    var mo, burst = 0;
    var run = function () { queued = false; place(grid, list); if (mo) mo.takeRecords(); };
    /* běžně hned (mikroúloha, bez probliknutí); kdyby se změny řetězily, nejvýš jednou za snímek */
    var kick = function () {
      if (queued) return;
      queued = true;
      if (++burst > 5) requestAnimationFrame(function () { burst = 0; run(); });
      else Promise.resolve().then(run);
    };
    setInterval(function () { burst = 0; }, 1000);
    mo = new MutationObserver(function (recs) {
      for (var i = 0; i < recs.length; i++) {
        var r = recs[i];
        if (r.type === 'childList' ? r.target === grid : r.target.parentElement === grid) { kick(); return; }
      }
    });
    mo.observe(grid, { childList: true, attributes: true, attributeFilter: ['class'], subtree: true });
    var t = 0;
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(kick, 150); });
    if (mq.addEventListener) mq.addEventListener('change', kick);
    run();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
